import './ChangeEvents.scss';
import { ApiRequests } from '@security/ApiRequests';
import { CHANGE_EVENT_PREFERENCES } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';
import { createAsyncSelectors } from '@lib/selectors';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { MonitoredObjects } from './MonitoredObjects';
import { SanitizedHtml } from '@ui/general';
import { When } from 'react-if';
import React, { useCallback } from 'react';
import { useAction, useAsyncState, useOnMount } from '@hooks';
const monitoredObjectSelectors = createAsyncSelectors((state) => state.core.dataSecurity.monitoredObjects.get);
const usageSelectors = createAsyncSelectors((state) => state.core.dataSecurity.usage.get);
export const ChangeEvents = ({ isEnabled, isLoading }) => {
    const { data: monitoredObjects, isRequested: isMonitoredObjectsRequested } = useAsyncState(monitoredObjectSelectors);
    const { data: usage, isRequested: isUsageRequested } = useAsyncState(usageSelectors);
    const hasData = Boolean(monitoredObjects === null || monitoredObjects === void 0 ? void 0 : monitoredObjects.totalCount);
    const loadObjects = useAction(coreActions.requestGetCoreDataSecurityMonitoredObjects);
    const loadUsage = useAction(coreActions.requestGetCoreDataSecurityUsage);
    const handleRefresh = useCallback(() => {
        loadObjects();
        loadUsage();
    }, [loadObjects, loadUsage]);
    useOnMount(() => {
        loadObjects();
        loadUsage();
    });
    return (React.createElement("div", { className: hasData ? 'monitored-objects' : '' },
        React.createElement(MonitoredObjects, { isEnabled: Boolean(isEnabled), loading: isMonitoredObjectsRequested || isLoading, monitoredObjects: monitoredObjects, onRefresh: handleRefresh, refreshing: isMonitoredObjectsRequested, salesforceUrl: usage === null || usage === void 0 ? void 0 : usage.sourceUrl }),
        React.createElement(When, { condition: hasData && isEnabled },
            React.createElement(LoadingSpinner, { spinning: isUsageRequested },
                React.createElement("div", { className: 'data-security-api-requests' },
                    (usage === null || usage === void 0 ? void 0 : usage.dailyDeliveredPlatformEvents) &&
                        React.createElement(ApiRequests, { header: CHANGE_EVENT_PREFERENCES.CHANGE_EVENTS_DAILY, maxCalls: usage.dailyDeliveredPlatformEvents.max, tooltip: React.createElement(SanitizedHtml, { as: 'span', html: CHANGE_EVENT_PREFERENCES.TOOLTIP_DAILY }), usedCalls: usage.dailyDeliveredPlatformEvents.max -
                                usage.dailyDeliveredPlatformEvents.remaining }),
                    (usage === null || usage === void 0 ? void 0 : usage.monthlyPlatformEventsUsageEntitlement) &&
                        React.createElement(ApiRequests, { header: CHANGE_EVENT_PREFERENCES.CHANGE_EVENTS_MONTHLY, maxCalls: usage.monthlyPlatformEventsUsageEntitlement.max, tooltip: React.createElement(SanitizedHtml, { as: 'span', html: CHANGE_EVENT_PREFERENCES.TOOLTIP_MONTHLY }), usedCalls: usage.monthlyPlatformEventsUsageEntitlement.max -
                                usage.monthlyPlatformEventsUsageEntitlement.remaining }))))));
};
